/* src/app/rt-components/footer/footer.component.scss */
:host {
  align-items: center;
  background: #ffffff;
  display: flex;
  font-size: 0.8rem;
  height: 3.1428572rem;
  justify-content: space-between;
  width: 100%;
}
@media screen and (max-width: 543px) {
  :host {
    font-size: 0.7rem;
  }
}
:host .copyright {
  text-align: center;
  flex: 1;
}
:host .copyright,
:host .version {
  padding: 10px 22px;
}
/*# sourceMappingURL=footer.component.css.map */
